<div
  class="fdk-card fdk-card--{{ variant }}"
  [class.fdk-card--selected]="selected"
>
  <div class="fdk-card__header">
    @if (logo && !logoLoadFailed) {
      <img
        class="fdk-card__logo"
        [src]="logo"
        alt=""
        (error)="handleLogoError()"
      />
    } @else if (initials) {
      <fdk-initials [initials]="initials" size="small" />
    }
    <div class="fdk-card__text">
      <div class="fdk-card__title">{{ title }}</div>
      @if (highlights.length) {
        <p class="fdk-card__highlights">Matches your search: <span [innerHTML]="highlights.join(', ')"></span></p>
      }
      @if (description) {
        <p class="fdk-card__description">{{ description }}</p>
      }
      @if (location.length) {
        <p class="fdk-card__location">
          <fdk-icon name="location-off" [size]="16" />
          <span>{{ location.join(', ') }}</span>
        </p>
      }
    </div>
  </div>
  @if (selected) {
    <div class="fdk-card__selected-indicator">
      <fdk-icon name="checkmark" [size]="24"></fdk-icon>
    </div>
  }
  @switch (variant) {
    @case ("more") {
      <div class="fdk-card__action">
        <fdk-icon name="chevron-right" [size]="24" />
      </div>
    }

    @case ("add") {
      <div class="fdk-card__action">
        <fdk-icon name="plus" [size]="24" />
      </div>
    }
    @case ("signIn") {
      <div class="fdk-card__sign-in">
        <span>Sign In</span>
      </div>
    }
  }
</div>
